"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.edit.title': 'Edit Profession',
};
